import React from 'react';
import { Shield } from 'lucide-react';
import { Card, CardContent } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Switch } from '../../../../components/ui/switch';
import type { SystemSettings } from '../../types';

interface SecuritySettingsProps {
  twoFactorAuth: boolean;
  passwordStrength: SystemSettings['security']['passwordStrength'];
  onTwoFactorAuthChange: (enabled: boolean) => void;
  onPasswordStrengthChange: (value: SystemSettings['security']['passwordStrength']) => void;
}

export const SecuritySettings: React.FC<SecuritySettingsProps> = ({
  twoFactorAuth,
  passwordStrength,
  onTwoFactorAuthChange,
  onPasswordStrengthChange
}) => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold flex items-center gap-2">
        <Shield className="h-5 w-5 text-[#e04530]" />
        Security Settings
      </h2>
      <Card className="border border-gray-200 bg-white">
        <CardContent className="p-6 space-y-4">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium">Two-Factor Authentication</h3>
                <p className="text-sm text-gray-500">Require 2FA for all admin users</p>
              </div>
              <Switch 
                checked={twoFactorAuth}
                onCheckedChange={onTwoFactorAuthChange}
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium">Password Requirements</h3>
                <p className="text-sm text-gray-500">Minimum password length and complexity</p>
              </div>
              <Select value={passwordStrength} onValueChange={onPasswordStrengthChange}>
                <SelectTrigger className="w-[180px] bg-white">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="basic">Basic</SelectItem>
                  <SelectItem value="strong">Strong</SelectItem>
                  <SelectItem value="very-strong">Very Strong</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 